var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconChevronDoubleLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 9,
    viewBox: "0 0 12 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "angle-double-left"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.0001 8.7496C4.90156 8.75007 4.80392 8.73085 4.71291 8.69307C4.6219 8.65529 4.53935 8.59972 4.4701 8.5296L1.0001 5.0296C0.859651 4.88898 0.780762 4.69835 0.780762 4.4996C0.780762 4.30085 0.859651 4.11023 1.0001 3.9696L4.4701 0.499603C4.61106 0.408212 4.77862 0.366791 4.94592 0.381978C5.11322 0.397166 5.27059 0.468083 5.39278 0.583362C5.51498 0.698641 5.59493 0.851607 5.61983 1.01774C5.64473 1.18388 5.61313 1.35357 5.5301 1.4996L2.5301 4.4996L5.5301 7.4996C5.67055 7.64023 5.74944 7.83085 5.74944 8.0296C5.74944 8.22835 5.67055 8.41898 5.5301 8.5596C5.38537 8.69029 5.1949 8.75858 5.0001 8.7496Z",
    fill: "#F8F9FA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.5001 8.74998C10.3072 8.73523 10.1277 8.64548 10.0001 8.49998L6.5001 4.99998C6.35965 4.85936 6.28076 4.66873 6.28076 4.46998C6.28076 4.27123 6.35965 4.08061 6.5001 3.93998L10.0001 0.499982C10.1401 0.433141 10.2973 0.411333 10.4502 0.43756C10.603 0.463787 10.744 0.536759 10.8537 0.646428C10.9633 0.756097 11.0363 0.89707 11.0625 1.04993C11.0888 1.20279 11.0669 1.36003 11.0001 1.49998L8.0001 4.49998L11.0001 7.49998C11.1231 7.63749 11.1911 7.8155 11.1911 7.99998C11.1911 8.18446 11.1231 8.36248 11.0001 8.49998C10.8725 8.64548 10.693 8.73523 10.5001 8.74998Z",
    fill: "#F8F9FA"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChevronDoubleLeft);
export default __webpack_public_path__ + "static/media/icon-chevron-double-left.ed24f7ea38b1825ec8fd3caeff9b1df8.svg";
export { ForwardRef as ReactComponent };